import { DocumentCheckIcon } from '@heroicons/react/24/outline';

interface NewsletterStatusProps {
  setIsRequestOk: (value: boolean) => void;
}

export function NewsletterStatus(props: NewsletterStatusProps) {
  const { setIsRequestOk } = props;

  return (
    <div className="justify-center flex flex-col items-center flex-1 p-5 gap-5 z-[100]">
      <DocumentCheckIcon className="h-10 w-10 animate-tada" />

      <h1 className="text-lg/6 font-semibold">
        Thanks for subscribing to our newsletters !
      </h1>

      <span
        className="text-center hover:underline text-primary-500 cursor-pointer"
        onClick={() => setIsRequestOk(false)}
      >
        Close
      </span>
    </div>
  );
}
